import "./App.css";
import Terminal from "./components/terminal";

function App() {
  return (
    <div className="App">
      <Terminal />
    </div>
  );
}

export default App;
